var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5644 1.09403C23.1042 1.57933 23.1484 2.41031 22.6631 2.95009L9.07412 18.0644C8.82473 18.3417 8.46922 18.5001 8.0962 18.4999C7.72318 18.4998 7.36781 18.3411 7.11866 18.0635L0.336178 10.5064C-0.148647 9.96617 -0.103758 9.13522 0.436442 8.65039C0.976641 8.16557 1.80759 8.21046 2.29241 8.75066L8.09764 15.2189L20.7084 1.19266C21.1937 0.652889 22.0246 0.608729 22.5644 1.09403Z",
    fill: "#F6F6F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.287a20f332b534f59a8c7a3d656ca3b0.svg";
export { ForwardRef as ReactComponent };